/**
 * Splits FullName to first nd last name
 *
 * @type {(fullname: string) => { firstName: string, lastName: string }}
 */
export const parseFullName = fullName => {
	const nameWords = fullName.trim().split(/\s+/);
	const lastName = nameWords.pop() || "";
	const firstName = nameWords.length > 0 ? nameWords.join(" ") : lastName;
	return { firstName, lastName };
};
